export default "__VITE_ASSET__951948cf__"